import Vue from 'vue'

Vue.filter('nl2br', function(str) {
    if(str) {
        return  str.replace(/\n/g,"<br />")
    } else {
        return null
    }
})



// WEBPACK FOOTER //
// ./src/filters/nl2br.js